module.exports = __webpack_public_path__ + "assets/smiley_icon.65dd1b09.svg";